export default "__VITE_ASSET__UvoQga1o__"